import axios from 'axios';
import { ENVIRONMENT_URL } from '../constants';

const api = axios.create({
    baseURL: 
    ENVIRONMENT_URL + "/app",
    //process.env.REACT_APP_BACKEND,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    }
});


export default api;